export default {
  path: '/configuracoes/:id',
  component: () => import('@/components/pages/Settings/Setting.vue')
}
